import { render, staticRenderFns } from "./SaleInfoNormal.vue?vue&type=template&id=4049a0f3&scoped=true&"
import script from "./SaleInfoNormal.vue?vue&type=script&lang=js&"
export * from "./SaleInfoNormal.vue?vue&type=script&lang=js&"
import style0 from "./SaleInfoNormal.vue?vue&type=style&index=0&id=4049a0f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049a0f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4049a0f3')) {
      api.createRecord('4049a0f3', component.options)
    } else {
      api.reload('4049a0f3', component.options)
    }
    module.hot.accept("./SaleInfoNormal.vue?vue&type=template&id=4049a0f3&scoped=true&", function () {
      api.rerender('4049a0f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/SaleInfoNormal.vue"
export default component.exports